import { SVGProps } from 'react';
import SpotifyIcon from './icons/SpotifyIcon';

type SpotifyButtonProps = {
  spotifyId: string;
  svgProps?: SVGProps<SVGSVGElement>;
  onClick: () => void;
};

function SpotifyButton({ spotifyId, onClick, svgProps }: SpotifyButtonProps): JSX.Element {
  return (
    <a href={`https://open.spotify.com/track/${spotifyId}`} target="_blank" rel="noopener noreferrer" onClick={onClick}>
      <SpotifyIcon {...svgProps} />
    </a>
  );
}

export default SpotifyButton;
